<template>
  <div class="filtersOverall" :class="{active: isSideBarOpen, toggled: isToggled}">
    <div class="filters">

      <div class="header--button" :class="{toggled: isToggled}" @click="toggleFilter()">
        <div class="hamburger hamburger--slider" >
          <div class="hamburger-box">
            <div class="hamburger-inner"></div>
          </div>
        </div>
      </div>
      <div class="filtersNav" v-bind:class="{ active: isToggled }">
        <div class="dropdown__menu" v-bind:class="{ active: isToggled }" v-if="isToggled">
          <ul class="dropdown__menu-nav">
            <li class="dropdown__menu-item"
              v-for="cat in categoryList" :key="cat.id">
              <label :for="cat.id" :class="cat.value" class="menu-item-label">
                {{cat.text}}
                <input type="checkbox" :id="cat.id" :value="cat.value" v-model="categories">
                <span class="checkmarky"></span>
              </label>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Filters',
  data() {
    return {
      isToggled: this.$store.state.filterToggled,
      categoryList: this.$store.state.categoryList,
      categories: this.$store.state.categories,
      isTempFilterChanged: this.$store.state.tempFilterChangePostLoad,
      isSideBarOpen: false,
      items: [],
    };
  },
  mounted() {
    this.setItems();
  },
  methods: {
    setItems() {
      this.$store.state.mapData.forEach((e) => {
        const marker = {
          lat: Number(e.lat), /* e.lat, */
          lng: Number(e.lng), /* e.lng, */
        };
        const item = {
          id: e.id,
          name: e.Name,
          description: e.Description,
          category: e.Filters,
          location: e.Location,
          image: e.Image,
          cta: e.cta,
          position: marker,
        };
        this.items.push(item);
      });
    },
    toggleFilter() {
      if (this.isToggled) {
        this.$store.commit('filterToggled', false);
        if (this.isSideBarOpen) {
          if (this.isTempFilterChanged) {
            this.$store.commit('closeSidebar');
            this.$store.commit('tempFilterChangePostLoad', false);
          }
        }
      } else {
        this.$store.commit('filterToggled', true);
      }
    },
  },
  updated() {
    // console.log('updated');
    if (this.isToggled) {
      if (this.isSideBarOpen) {
        // console.log('ext case');
        document.querySelectorAll('.dropdown__menu-item').forEach((item) => {
          item.addEventListener('click', () => {
            this.$store.commit('tempFilterChangePostLoad', true);
          });
        });
      }
    }
  },
  computed: {
    matchedItems() {
      return this.categories.length
        // ? this.items.filter((item) => this.categories.includes(item.category))
        ? this.items.filter((item) => {
          const itemCategories = item.category.split(',').join('');
          // console.log('Item Category: ', itemCategories, 'Categories: ', this.categories);
          return this.categories.some((e) => itemCategories.includes(e));
          // return this.categories.includes(item.category);
        })
        : this.items;
    },
    selectedItems() {
      return this.matchedItems;
    },
    sideBarOpen() {
      return this.$store.state.sideBarOpen;
    },
    filterToggled() {
      return this.$store.state.filterToggled;
    },
    tempFilterChangePostLoad() {
      return this.$store.state.tempFilterChangePostLoad;
    },
  },
  watch: {
    sideBarOpen(newSidebar) {
      this.isSideBarOpen = newSidebar;
    },
    filterToggled(newToggle) {
      this.isToggled = newToggle;
    },
    tempFilterChangePostLoad(checkFilterChange) {
      this.isTempFilterChanged = checkFilterChange;
    },
    matchedItems(items) {
      const itemCategories = items.map((item) => item.category);
      const uniqueItemCategories = itemCategories.reduce((acumulator, currentValue) => {
        if (!acumulator.includes(currentValue)) {
          acumulator.push(currentValue);
        }
        return acumulator;
      }, []);
      this.$store.commit('updateCategories', uniqueItemCategories);
    },
    selectedItems(newSelectedItems) {
      this.$store.commit('updateSidebarLocations', newSelectedItems);
    },
  },
};
</script>

<style lang="scss" scoped>
.filtersOverall {
  &.active.toggled {
    position: absolute;
    height: 100vh;
    width: 340px;
    background-color: var(--greenUI);
    z-index: 6;
    @media only screen and (max-width: 767px) {
      width: 100%;
    }

    .header--button {
      background-color: var(--greenUIDark);
      border-radius: 2px 2px 2px 2px;
    }
  }
  &.active {
    .filters {
      z-index: 6;
    }
  }
}

.filters {
  text-align: left;
  position: absolute;
  left: 20px;
  top: 20px;
  z-index: 5;
  width: 100%;
  max-width: 300px;
  border-radius: 2px;
  @media only screen and (max-width: 767px) {
    max-width: 90%;
  }
}
.header--button {
  cursor: pointer;
  background-color: var(--greenUI);
  width: 42px;
  height: 42px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  .hamburger {
    padding: 15px 15px;
    display: inline-block;
    cursor: pointer;
    transition-property: opacity, filter;
    transition-duration: 0.15s;
    transition-timing-function: linear;
    font: inherit;
    color: inherit;
    text-transform: none;
    background-color: transparent;
    border: 0;
    margin: 0;
    overflow: visible;

    &:hover {opacity: 0.7;}
    &.is-active:hover {opacity: 0.7;}
    &.is-active .hamburger-inner,
    &.is-active .hamburger-inner::before,
    &.is-active .hamburger-inner::after {
      background-color: #000;
    }

    .hamburger-box {
      width: 20px;
      height: 20px;
      display: flex;
      position: relative;

      .hamburger-inner {
        display: block;
        top: 4px;
      }
      .hamburger-inner,
      .hamburger-inner::before,
      .hamburger-inner::after {
        width: 20px;
        height: 2px;
        margin: 0 auto;
        background-color: #fff;
        border-radius: 4px;
        position: absolute;
        transition-property: transform;
        transition-duration: 0.15s;
        transition-timing-function: ease;
      }
      .hamburger-inner::before,
      .hamburger-inner::after {
        content: "";
        display: block;
      }
      .hamburger-inner::before {
        width: 15px;
        top: 5px;
        left: 2px;
        transition-property: transform, opacity;
        transition-timing-function: ease;
        transition-duration: 0.15s;
      }
      .hamburger-inner::after {
        width: 10px;
        top: 10px;
        left: 4px;
      }
    }
  }

  .hamburger--slider .hamburger-inner {
    top: 2px;
  }
  .hamburger--slider .hamburger-inner::before {
    top: 10px;
    transition-property: transform, opacity;
    transition-timing-function: ease;
    transition-duration: 0.15s;
  }
  .hamburger--slider .hamburger-inner::after {
    top: 20px;
  }

  &.toggled {
    .hamburger--slider {
      .hamburger-inner {
        transform: translate3d(0, 4px, 0) rotate(45deg);
        &::before {
          transform: rotate(-45deg) translate3d(-5.71429px, -6px, 0);
          opacity: 0;
        }
        &::after {
          width: 20px;
          transform: translate3d(-4px, -10px, 0) rotate(-90deg);
        }
      }
    }
  }
}
@keyframes fadeInOpacity {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

.filtersNav {
  background-color: var(--greenUI);
  color: #fff; border-radius: 0 3px 3px 3px;
  // display: block;
  opacity: 1;
  animation-name: fadeInOpacity;
  animation-iteration-count: 1;
  animation-timing-function: ease-in;
  animation-duration: 0.5s;

  .dropdown__menu.active {
    opacity: 1;
    animation-name: fadeInOpacity;
    animation-iteration-count: 1;
    animation-timing-function: ease-in;
    animation-duration: 0.5s;
  }

  ul {
    list-style-type: none;
    padding: 20px 10px;
    margin: 0;
    overflow: hidden;

    li {
      display: flex;
      height: 28px;
      padding-bottom: 20px;

      label.menu-item-label {
        width: 100%;
        position: relative;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
        font: normal 12px/28px 'Roboto';
        cursor: pointer;
        display: flex;
        margin: 0 0 0 0;

        &::before{
          content: ''; margin: 0 10px 0 0; width: 28px; height: 28px;
        }
        &::after{display: none;
          content: ''; width: 6px; height: 28px; border: 1px solid #fff;
          position: absolute; left: -21px;
        }
        &.climate::before{
          background: url(../assets/icons/climate.svg) no-repeat 0 0 transparent;
        }
        &.climate::after{
          background-color: var(--climate);
        }
        &.climate .checkmarky {
          background-color: var(--climate);
        }
        &.future::before{
          background: url(../assets/icons/future.svg) no-repeat 0 0 transparent;
        }
        &.future::after{
          background-color: var(--future);
        }
        &.future .checkmarky {
          background-color: var(--future);
        }
        &.housing::before{
          background: url(../assets/icons/housing.svg) no-repeat 0 0 transparent;
        }
        &.housing::after{
          background-color: var(--housing);
        }
        &.housing .checkmarky {
          background-color: var(--housing);
        }
        &.retirement::before{
          background: url(../assets/icons/retirement.svg) no-repeat 0 0 transparent;
        }
        &.retirement::after{
          background-color: var(--retirement);
        }
        &.retirement .checkmarky {
          background-color: var(--retirement);
        }
        &.sme::before{
          background: url(../assets/icons/sme.svg) no-repeat 0 0 transparent;
        }
        &.sme::after{
          background-color: var(--sme);
        }
        &.sme .checkmarky {
          background-color: var(--sme);
        }
        &.urban::before{
          background: url(../assets/icons/urban.svg) no-repeat 0 0 transparent;
        }
        &.urban::after{
          background-color: var(--urban);
        }
        &.urban .checkmarky {
          background-color: var(--urban);
        }

        &:hover input ~ .checkmarky {
          opacity: 0.75;
        }

        input {
          position: absolute;
          opacity: 0;
          cursor: pointer;
          height: 0;
          width: 0;
        }

        /* Create a custom checkbox */
        .checkmarky {
          position: absolute;
          top: 6px;
          right: 10px;
          height: 15px;
          width: 15px;
          background-color: transparent;
          border: 1px solid #fff;
          border-radius: 5px;
        }

        // input:checked ~ .checkmarky {
        //   // background-color: var(--greenCheckmark);
        // }

        /* Create the checkmarky/indicator (hidden when not checked) */
        .checkmarky:after {
          content: "";
          position: absolute;
          display: none;
        }

        /* Show the checkmarky when checked */
        input:checked ~ .checkmarky:after {
          display: block;
        }

        /* Style the checkmarky/indicator */
        .checkmarky:after {
          left: 5px;
          top: 0px;
          width: 5px;
          height: 10px;
          border: solid #fff;
          border-width: 0 1px 1px 0;
          transform: rotate(45deg);
        }
        &.sme .checkmarky:after {
          border: solid #333;
          border-width: 0 1px 1px 0;
        }
      }
    }
  }
}

.slide-fade-enter {
  transform: translateX(31px);
}
.slide-fade-leave-active {
  transform: translateX(-31px);
}

.dropdown-enter-active {
  transition: all 1s;
}
.dropdown-leave-active {
  transition: all 0.15s;
}
.dropdown-enter,
.dropdown-leave-to {
  opacity: 0;
  transform: translateY(0px);
}

</style>
